var map = {
	"./check.svg": [
		597,
		1
	],
	"./chevron-down.svg": [
		598,
		2
	],
	"./close.svg": [
		599,
		3
	],
	"./copy.svg": [
		600,
		4
	],
	"./crown-bronze.svg": [
		601,
		5
	],
	"./crown-gold.svg": [
		602,
		6
	],
	"./crown-silver.svg": [
		603,
		7
	],
	"./crown.svg": [
		604,
		8
	],
	"./discord.svg": [
		605,
		9
	],
	"./flag.svg": [
		606,
		10
	],
	"./instagram.svg": [
		607,
		11
	],
	"./list.svg": [
		608,
		12
	],
	"./logout.svg": [
		609,
		13
	],
	"./options.svg": [
		610,
		14
	],
	"./remove.svg": [
		611,
		15
	],
	"./shopping-cart.svg": [
		612,
		16
	],
	"./tick.svg": [
		613,
		17
	],
	"./user.svg": [
		614,
		18
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 315;
module.exports = webpackAsyncContext;